// Carousel.js
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";

const Pictures = () => {
  const swiperRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const carouselItems = [
    {
      id: 1,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Celebrating 25 Years of Excellence at EbunHeritage School.",
      bg1: "bg-primary slide02",
      bg2: "bg-q1 slide1",
      bg3: "bg-q1 slide015",
    },
    {
      id: 2,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "A Legacy of Knowledge, Leadership & Integrity.",
      bg1: "bg-primary slide03",
      bg2: "bg-q1 slide2",
      bg3: "bg-q1 slide01",
    },
    {
      id: 3,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "25 Years of Raising Future Champions.",
      bg1: "bg-primary slide04",
      bg2: "bg-q1 slide3",
      bg3: "bg-q1 slide02",
    },
    {
      id: 4,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Inspiring Minds. Building Dreams.",
      bg1: "bg-primary slide05",
      bg2: "bg-q1 slide4",
      bg3: "bg-q1 slide03",
    },
    {
      id: 5,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "From Humble Beginnings to Great Achievements.",
      bg1: "bg-primary slide06",
      bg2: "bg-q1 slide5",
      bg3: "bg-q1 slide04",
    },
    {
      id: 6,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Empowering Students Since Day One.",
      bg1: "bg-primary slide07",
      bg2: "bg-q1 slide6",
      bg3: "bg-q1 slide05",
    },
    {
      id: 7,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Excellence in Academics, Character & Creativity.",
      bg1: "bg-primary slide08",
      bg2: "bg-q1 slide7",
      bg3: "bg-q1 slide06",
    },
    {
      id: 8,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Celebrating Generations of Success Stories.",
      bg1: "bg-primary slide09",
      bg2: "bg-q1 slide8",
      bg3: "bg-q1 slide07",
    },
    {
      id: 9,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Where Excellence is a Tradition.",
      bg1: "bg-primary slide010",
      bg2: "bg-q1 slide9",
      bg3: "bg-q1 slide08",
    },
    {
      id: 10,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Nurturing Tomorrow’s Leaders Today.",
      bg1: "bg-primary slide011",
      bg2: "bg-q1 slide10",
      bg3: "bg-q1 slide09",
    },
    {
      id: 11,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "25 Years of Passion, Purpose & Progress.",
      bg1: "bg-primary slide012",
      bg2: "bg-q1 slide11",
      bg3: "bg-q1 slide010",
    },
    {
      id: 12,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Shaping Bright Futures, One Student at a Time.",
      bg1: "bg-primary slide013",
      bg2: "bg-q1 slide12",
      bg3: "bg-q1 slide011",
    },
    {
      id: 13,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "A Journey of Dedication and Distinction.",
      bg1: "bg-primary slide014",
      bg2: "bg-q1 slide13",
      bg3: "bg-q1 slide012",
    },
    {
      id: 14,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "Honoring the Past. Celebrating the Present.",
      bg1: "bg-primary slide015",
      bg2: "bg-q1 slide14",
      bg3: "bg-q1 slide013",
    },
    {
      id: 15,
      color: "#005826",
      bg: "bg-trans",
      textcolor: "text-dark",
      description: "EbunHeritage @ 25 — The Legacy Continues.",
      bg1: "bg-primary slide01",
      bg2: "bg-q1 slide15",
      bg3: "bg-q1 slide014",
    },
];


  const next = () => swiperRef.current?.slideNext();
  const previous = () => swiperRef.current?.slidePrev();

  return (
    <>
      <Swiper
        modules={[Pagination, EffectFade]}
        effect="fade"
        fadeEffect={{ crossFade: true }}   // ✅ prevents overlapping slides
        speed={600}
        slidesPerView={1}
        centeredSlides={false}             // ✅ important for fade (avoid double render)
        loop={true}
        allowTouchMove={false}             // ✅ prevents laggy drag issues
        watchSlidesProgress={true}
        observer={true}
        observeParents={true}
        preventInteractionOnTransition={true}  // ✅ stops glitch during auto slide
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
        style={{ width: "100%" }}          // ✅ prevents layout jump
      >
        {carouselItems.map((item) => (
          <SwiperSlide key={item.id}>
            {/* ⬇️ NOTHING BELOW IS CHANGED */}
            <div className="d-flex justify-content-between mb-lg-20">
              <div className="col-lg-2 d-none d-lg-block">
                <div
                  className={`card shadow-none px-4 ${item.bg3}`}
                  style={{
                    borderTopRightRadius: "24px",
                    borderBottomRightRadius: "24px",
                  }}
                />

                <div className="text-end mt-17 me-n3">
                  <div
                    className="btn btn-primary btn-lg rounded-circle mt-2"
                    onClick={previous}
                  >
                    <span className="bi bi-arrow-left fs-3"></span>
                  </div>

                  <div
                    className="btn btn-primary btn-lg rounded-circle mt-2 ms-2"
                    onClick={next}
                  >
                    <span className="bi bi-arrow-right fs-3"></span>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-8 me-lg-n6 px-lg-3 px-3">
                <div className="d-lg-flex">
                  <div className="col-lg-6">
                    <div
                      className="card shadow-none py-lg-8 py-6"
                      style={{
                        backgroundImage: "url('../../assets/images/background/spiral.svg')",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "24px"
                      }}
                    >
                      <div className="mt-lg-5 px-lg-8 px-6 mb-lg-20">
                      <CountdownCircleTimer
                        key={currentIndex}               // 🔁 forces restart on slide change
                        isPlaying
                        duration={8}
                        colors={item.color}
                        size={isMobile ? 50 : 60}
                        strokeWidth={3}
                        rotation="counterclockwise"
                        onComplete={() => {
                          swiperRef.current?.slideNext(); // 👉 auto move
                          return { shouldRepeat: false }; // key handles restart
                        }}
                      >
                        {() => (
                          <span className={`fs-4 ${item.textcolor}`}>
                            {item.id}
                          </span>
                        )}
                      </CountdownCircleTimer>

                      </div>

                      <div className="mt-lg-20 mt-6 mb-lg-2 mb-8 px-lg-8 me-4 px-6">
                        <span className={`fs-m lg:text-[40px] ${item.textcolor}`}>
                          {item.description}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`col-lg-6 ms-lg-n6 ${
                      isMobile ? "mt-n6" : ""
                    }`}
                  >
                    <div
                      className={`card shadow-none ${item.bg2} py-20 py-lg-20 px-lg-2`}
                      style={{ borderRadius: "24px" }}
                    />
                  </div>
                </div>

                <div className="text-center mt-7 d-block d-lg-none">
                  <div
                    className="btn btn-primary btn-lg rounded-circle mt-2"
                    onClick={previous}
                  >
                    <span className="bi bi-arrow-left fs-3"></span>
                  </div>

                  <div
                    className="btn btn-primary btn-lg rounded-circle mt-2 ms-2"
                    onClick={next}
                  >
                    <span className="bi bi-arrow-right fs-3"></span>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 d-none d-lg-block">
                <div
                  className={`card shadow-none py-14 px-4 ${item.bg1}`}
                  style={{
                    borderTopLeftRadius: "24px",
                    borderBottomLeftRadius: "24px",
                  }}
                />

                <div className="text-start mt-17 ms-n3">
                  <Link
                    to="/entrance"
                    className="btn btn-primary btn-lg rounded-3 shadow-none mt-2 fs-4 fw-medium"
                  >
                    Join Us Now
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default Pictures;
